import React from 'react';
import { useParams } from 'react-router-dom';
import useProjects from '../hooks/useProjects';
import { ArrowRightIcon } from '@heroicons/react/solid'

const ProjectDetail = () => {
    const { id } = useParams();
    const projectId = JSON.parse(id);
    const [projects] = useProjects();
    const project = projects.find(p => p.id === projectId);

    return (
        <div>
            <div class="hero min-h-screen text-white p-12">
                <div class="hero-content flex-col lg:flex-row-reverse">
                    <img src={project?.image} class="lg:max-w-lg rounded-lg shadow-2xl" alt='' />
                    <div>
                        <h1 class="text-5xl font-bold">{project?.name}</h1>
                        <div className='text-center my-8 bg-cyan-600 rounded-md p-4'>
                            <h3 className='font-bold text-2xl'>Technology Stack</h3>
                            <ul className=''>{project?.techStack.map((t, index) => <li key={index}>{t}</li>)}</ul>
                        </div>
                        {project?.description.map((d, index) =>
                            <div
                                key={index}
                                className="flex items-center my-2 bg-cyan-600 p-4 rounded-md">
                                <p className='mr-2'><ArrowRightIcon className='w-5 h-5'></ArrowRightIcon></p>
                                <p className='text-lg'>{d}</p>
                            </div>
                        )}

                    </div>
                </div>
            </div>
            <h3 className='text-3xl font-bold text-white text-center my-5'>Gallery</h3>
            <div class="carousel w-full">
                <div id="slide1" class="carousel-item relative w-full">
                    <img src={project?.gallery[0]} class="w-full" alt='' />
                    <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
                        <a href="#slide5" class="btn btn-circle">❮</a>
                        <a href="#slide2" class="btn btn-circle">❯</a>
                    </div>
                </div>
                <div id="slide2" class="carousel-item relative w-full">
                    <img src={project?.gallery[1]} class="w-full" alt='' />
                    <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
                        <a href="#slide1" class="btn btn-circle">❮</a>
                        <a href="#slide3" class="btn btn-circle">❯</a>
                    </div>
                </div>
                <div id="slide3" class="carousel-item relative w-full">
                    <img src={project?.gallery[2]} class="w-full" alt='' />
                    <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
                        <a href="#slide2" class="btn btn-circle">❮</a>
                        <a href="#slide4" class="btn btn-circle">❯</a>
                    </div>
                </div>
                <div id="slide4" class="carousel-item relative w-full">
                    <img src={project?.gallery[3]} class="w-full" alt='' />
                    <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
                        <a href="#slide3" class="btn btn-circle">❮</a>
                        <a href="#slide5" class="btn btn-circle">❯</a>
                    </div>
                </div>
                <div id="slide5" class="carousel-item relative w-full">
                    <img src={project?.gallery[4]} class="w-full" alt='' />
                    <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
                        <a href="#slide4" class="btn btn-circle">❮</a>
                        <a href="#slide1" class="btn btn-circle">❯</a>
                    </div>
                </div>
            </div>
            <a rel='noreferrer' target={"_blank"} href={project?.liveSiteLink} className='text-3xl font-bold text-white text-center'>Visit live site to see more</a>
        </div>
    );
};

export default ProjectDetail;